export var mapSubproduct = function mapSubproduct(subproduct) {
  switch (subproduct) {
    case 'business':
      return 'core';
    case 'product_discovery':
      return 'polaris';
    case 'software':
      return 'software';
    case 'service_desk':
      return 'serviceDesk';
    default:
      return subproduct;
  }
};